<script>
  import ModalLiberarCancelar from '~componentes/ModalLiberarCancelar.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import solicitacaoPagamentoServico from '~modulos/solicitacao-pagamento/servico.js';
  import solicitacaoPagamentoRateioServico from '~modulos/solicitacao-pagamento-rateio/servico.js';
  import ModalMensagem from '~componentes/ModalMensagem.vue';

  export default {
    components: { ModalLiberarCancelar, ModalArquivosSolicitacao, ModalMensagem },
    props: {
      solicitacoes: {
        required: true
      },
      projetos: {
        required: true,
      }
    },
    data() {
      return {
        solicitacaoSelecionada: null,
        projetoSolicitacaoSelecionada: null,
        modalLiberarCancelar: false,
        salvandoLiberacao: false,
        animated: false,
        modalArquivos: false,
        configuracao: this.$storage.configuracao(),
        modalMensagem: false,
      }
    },
    methods: {
      mostrarModalLiberarCancelar(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.projetoSolicitacaoSelecionada = this.projetos
          .find(projeto => projeto.nomeProjeto === solicitacao.nomeProjeto);
        this.modalLiberarCancelar = true;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      liberar() {
        this.salvandoLiberacao = true;

        if (this.configuracao.utilizarRateioSolicitacoes) {
          solicitacaoPagamentoRateioServico
            .liberar(this.solicitacaoSelecionada.idSolicitacaoCript)
            .then(status => {
              this.modalLiberarCancelar = false;

              if (status.liberado) {
                toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacao} liberada com sucesso.`);
              } else {
                toastr.warning(`Você não tem permissão para liberar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
              }

              this.salvandoLiberacao = false;
              this.solicitacaoSelecionada = null;
              this.projetoSolicitacaoSelecionada = null;
              $('body').removeClass('modal-open');
            })
            .then(this.lista);
        }
        else {
          solicitacaoPagamentoServico
            .liberar(this.solicitacaoSelecionada.idSolicitacao)
            .then(status => {
              this.modalLiberarCancelar = false;

              if (status.liberado) {
                toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacao} liberada com sucesso.`);
              } else {
                toastr.warning(`Você não tem permissão para liberar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
              }

              this.salvandoLiberacao = false;
              this.solicitacaoSelecionada = null;
              this.projetoSolicitacaoSelecionada = null;
              $('body').removeClass('modal-open');
            })
            .then(this.lista);
        }
      },
      cancelar() {
        this.salvandoLiberacao = true;

        if (this.configuracao.utilizarRateioSolicitacoes) {
          solicitacaoPagamentoRateioServico
            .cancelar(this.solicitacaoSelecionada.idSolicitacaoCript)
            .then(status => {
              this.modalLiberarCancelar = false;

              if (status.cancelado) {
                toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacao} cancelada com sucesso.`);
              } else {
                toastr.warning(`Você não tem permissão para cancelar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
              }

              this.salvandoLiberacao = false;
              this.solicitacaoSelecionada = null;
              this.projetoSolicitacaoSelecionada = null;
            })
            .then(this.lista);
        }
        else {
          solicitacaoPagamentoServico
            .cancelar(this.solicitacaoSelecionada.idSolicitacao)
            .then(status => {
              this.modalLiberarCancelar = false;

              if (status.cancelado) {
                toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacao} cancelada com sucesso.`);
              } else {
                toastr.warning(`Você não tem permissão para cancelar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
              }

              this.salvandoLiberacao = false;
              this.solicitacaoSelecionada = null;
              this.projetoSolicitacaoSelecionada = null;
            })
            .then(this.lista);
        }
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarCancelar = false;
        this.solicitacaoSelecionada = null;
        this.projetoSolicitacaoSelecionada = null;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
        this.projetoSolicitacaoSelecionada = null;
      },
      lista(pagina = 1) {
        this.solicitacoes.pagina = pagina;

        this.$emit('lista');
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.projetoSolicitacaoSelecionada = null;
        this.lista(this.pagina);
      },
    },
    computed: {
      retornaRotaPgtoPF() {
        return 'solicitacao-pagamento-estrangeiro-pf.relatorio'
      }
    }
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>
  <div class="group">
      <modal-liberar-cancelar :mostrar="modalLiberarCancelar"
                              :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                              :salvando="salvandoLiberacao"
                              :liberando="configuracao.solPagamentoEstrangeiroPFMsgConfirmacao ? false : true"
                              :mensagem="configuracao.solPagamentoEstrangeiroPFMsgConfirmacao"
                              :dataLimite="projetoSolicitacaoSelecionada
                              ? projetoSolicitacaoSelecionada.dataLimiteSolicitacao
                              : ''"
                              @fechado="modalLiberarCancelarFechado"
                              @liberar="liberar"
                              @cancelar="cancelar">
      </modal-liberar-cancelar>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                                tipo="pagamento"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCrypt : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    tipo="SolPagamentoPF"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="table-responsive">
      <table class="table table-bordered table-column-code table-column-action">
        <thead>
          <tr>
            <th v-if="!configuracao.naoUtilizarMensageria">Mensagens</th>
            <th class="text-center">Número</th>
            <th>Solicitante</th>
            <th>Projeto</th>
            <th>Beneficiário</th>
            <th>Data solicitação</th>
            <th>Previsão</th>
            <th>Valor (R$)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(solicitacao, index) in solicitacoes">
            <td v-if="!configuracao.naoUtilizarMensageria">
              <div v-if="solicitacao.quantidadeNaoLida > 0">
                <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{solicitacao.quantidadeNaoLida}}
              </div>
            </td>
            <td class="text-center">{{ solicitacao.idSolicitacao }}</td>
            <td>{{ solicitacao.solicitante || '---' }}</td>
            <td>{{ solicitacao.nomeProjeto || '---' }}</td>
            <td>{{ solicitacao.nome || '---' }}</td>
            <td>{{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}</td>
            <td>{{ solicitacao.dataProvisao | formatarData }}</td>
            <td>{{ solicitacao.valor | formatarNumero }}</td>
            <td>
              <router-link class="btn btn-primary btn-xs"
                           active-class=""
                           v-tooltip="'Relatório'"
                           :to="{ name: retornaRotaPgtoPF, params: { id: solicitacao.idSolicitacao, rota: 'liberar-solicitacoes' } }">
                <i class="fa fa-file-text-o"></i>
              </router-link>

              <button v-if="!configuracao.usoEmailLiberarSolicitacao"
                      class="btn btn-warning btn-xs"
                      v-tooltip="'Liberar ou Cancelar solicitação'"
                      @click="mostrarModalLiberarCancelar(solicitacao)">
                <i class="fa fa-check"></i>
              </button>

              <button type="button"
                      class="btn btn-info btn-xs"
                      v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                      @click="mostrarModalArquivos(solicitacao)"
                      v-if="configuracao.usarArquivosSolicitacaoPagamentos">
                <i class="fa fa-archive"></i>
              </button>

              <button type="button"
                      class="btn btn-success btn-xs"
                      v-tooltip="'Ler\Enviar mensagem'"
                      @click="mostrarModalMensagem(solicitacao)"
                      v-if="!configuracao.naoUtilizarMensageria">
                <i class="fa fa-comment"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-solicitacoes/componentes/compartilhado/LiberarSolicitacaoPagamentoEstrangeiroPf.vue